import { InjectionToken } from '@angular/core';
import { FileWebServiceInterface } from '@commons/file-picker/services/file.web-service.interface';

export const FILE_PICKER_UPLOAD_SERVICE_TOKEN = new InjectionToken<FileWebServiceInterface>(
  'Service used to upload Wizbii file picker input'
);
